import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import sanitaryMachine from "../../../../../assets/images/OUR SERVICES/4. Sanitary napkins machine.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const SanitoryMachine = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Sanitary Pad Vending Machine</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12} className="text-center">
                                    <img
                                        src={sanitaryMachine}
                                        alt="Office Stationery"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>
                                    <p className="text-black"> <strong>Hygienic & Convenient</strong> – Provides easy access to sanitary pads anytime, anywhere.</p>
                                    <p className="text-black"> <strong>Quick & Hassle-Free</strong> – Dispenses pads instantly with a simple press of a button.</p>
                                    <p className="text-black"> <strong>Ideal for Public & Private Spaces</strong> – Perfect for schools, colleges, offices, malls, restrooms, and hospitals.</p>
                                    <p className="text-black"> <strong>Compact & User-Friendly Design</strong> – Easily installable in restrooms and common areas.</p>
                                    <p className="text-black"> <strong>Ensures Privacy & Dignity</strong> – Designed to offer discreet access to feminine hygiene products.</p>
                                    <p className="text-black"> <strong>Low Maintenance & High Durability</strong> – Built for long-term use with minimal upkeep.</p>
                                    <p className="text-black"> <strong>Eco-Friendly & Sustainable</strong> – Some models support biodegradable pad options.</p>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default SanitoryMachine;